module.exports = __webpack_public_path__ + "static/media/docker.bb06a818.svg";